import styled from 'styled-components';
import {
    Text,
} from '@zillow/constellation';

export const StyledText = styled(Text)`
    color: #777;
`;
